module.exports = __webpack_public_path__ + "static/media/producing_asset_1.ece37143.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/producing_asset_1.jpg
// module id = 1853
// module chunks = 0